import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogWrapper } from 'src/app/shared/services/DialogWrapper';

// Confirmation modal for actions that would void a pending plan change.
// Returns true on Continue, false on Cancel.
@Component({
  templateUrl: './confirm-cancel-solo-downgrade-dialog.component.html',
})
export class ConfirmCancelSoloDowngradeDialogComponent extends DialogWrapper<
  ConfirmCancelSoloDowngradeDialogComponent,
  void,
  boolean
> {
  public matDialogData: void;

  constructor(public dialogRef: MatDialogRef<ConfirmCancelSoloDowngradeDialogComponent, boolean>) {
    super();
  }

  protected onContinue = (): void => {
    this.dialogRef.close(true);
  };

  protected onCancel = (): void => {
    this.dialogRef.close(false);
  };
}
